export default [
  {
    path: '/relGraficoBalancoMensal/',
    name: 'relGraficoBalancoMensal',
    title: 'relGraficoBalancoMensal',
    component: () => import('../views/RelGraficoBalancoMensalView.vue'),
    redirect: { name: 'relGraficoBalancoMensal-listar' },
    children: [
      {
        path: 'welcome',
        name: 'relGraficoBalancoMensal-listar',
        component: () => import('../views/RelGraficoBalancoMensalWelcomeView.vue'),
        meta: {
          title: 'Gráfico de balanço mensal',
        },
      },
    ],
  },
];
